import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

interface propTypes {
  title: string
  text: string
  buttonText: string
  buttonPath: string
}
const TextSection: React.FC<propTypes> = (props) => {
  const { title, text, buttonText, buttonPath } = props
  return (
    <Box sx={{ backgroundColor: '#fcfcfc' }}>
      <Box
        sx={{
          py: 5,
          height: '100%',
          width: { md: '60%' },
          m: 'auto',
          px: { xs: 3, md: 6 },
        }}
      >
        <Typography
          variant="h5"
          fontWeight="500"
          sx={{ mb: 2.5, textAlign: { md: 'center' } }}
        >
          {title}
        </Typography>
        <Typography
          variant="h6"
          fontWeight="400"
          sx={{ textAlign: { md: 'center' } }}
        >
          {text}
        </Typography>
        <Button
          variant="contained"
          sx={{
            mt: 6,
            textTransform: 'none',
            color: '#fff',
            display: 'flex',
            mx: 'auto',
          }}
        >
          <Link
            to={buttonPath}
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            {buttonText}
          </Link>
        </Button>
      </Box>
    </Box>
  )
}

export default TextSection
